import { usePricelistProductChannelPricesQuery } from "@/generated/graphql";
import { useCallback, useMemo } from "react";

export const usePricelistProductChannelPrices = (
	pricelistProductID?: string,
) => {
	// urql re-executes whenever context changes identity, so an inline object loops the render.
	const context = useMemo(() => ({ suspense: false }), []);
	const [{ data, error, fetching }, fetch] =
		usePricelistProductChannelPricesQuery({
			variables: { pricelistProductID },
			// A pricelist price that is not saved yet cannot own channel prices.
			pause: !pricelistProductID,
			requestPolicy: "network-only",
			context,
		});

	const load = useCallback(() => {
		fetch();
	}, [fetch]);

	return {
		data,
		error,
		fetching,
		load,
	};
};
